export default __webpack_public_path__ + "static/media/bblc.62a71cc9.jpg";